import React from "react";
import {
  Progress,
  List,
  ListItem,
  ListIcon,
  OrderedList,
  UnorderedList,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  RadioGroup,
  Stack,
  Radio,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Checkbox,
  SimpleGrid,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuIcon,
  MenuCommand,
  MenuDivider,
  Wrap,
  WrapItem,
  Box,
  Flex,
  Button,
  Text,
  Input,
  IconButton,
  Icon,
  useColorMode,
  Spinner
} from "@chakra-ui/react";
import { createBreakpoints } from "@chakra-ui/theme-tools";
import {
  ChevronDownIcon,
  ExternalLinkIcon,
  ViewOffIcon
} from "@chakra-ui/icons";
import NavBar from "../widgets/NavBar";
import Footer from "../widgets/Footer";
import LoginContext from "../../context/LoginContext";

import { database } from "../../firebase";

function loadList(value, index, colorMode, onOpen, preview) {
  return (
    <Flex
      onClick={(e) => {
        // console.log(e.target);
        // console.log(e.target.toString());
        let val = e.target.toString();
        if (
          !val.includes("SVGSVGElement") &&
          !val.includes("HTMLButtonElement") &&
          !val.includes("SVGPathElement")
        ) {
          window.open(`/campaigns/${value.id}`, "_blank");
        }
      }}
      key={index}
      cursor="pointer"
      _hover={{
        transform: "translateY(-2px)",
        boxShadow: "lg"
      }}
      wrap="wrap"
      flexDirection="column"
      borderWidth="2px"
      borderRadius="lg"
      width={{ base: "95vw", md: "1000px" }}
      p={4}
      marginBottom={2}>
      <Flex mb={3} justifyContent="space-between" wrap="wrap">
        <Text>{value.camapignTitle}</Text>
        <SimpleGrid columns={2} spacing={2}>
          <IconButton
            bg={colorMode === "dark" ? undefined : "white"}
            icon={<Icon as={ExternalLinkIcon} />}
            onClick={() => {
              onOpen();
              preview(value);
            }}
          />
          <IconButton
            bg={colorMode === "dark" ? undefined : "white"}
            icon={<Icon as={ViewOffIcon} />}
          />
        </SimpleGrid>
      </Flex>

      <Flex mt={3} justifyContent="space-between" wrap="wrap">
        <Text marginEnd={5}>{value.campaign_region}</Text>
        <Text marginEnd={5}>Starter</Text>
        <Flex flexDirection="column" justifyContent="space-between">
          <Text marginEnd={5}>
            {value.campaign_work_done} of {value.campaign_workers_need} Done
          </Text>
          <Progress
            height="6px"
            width="104px"
            colorScheme="blue"
            size="sm"
            value={value.campaign_work_done}
            min={0}
            max={value.campaign_workers_need}
          />
        </Flex>
        <Flex
          flexDirection="column"
          justsifyContent="center"
          alignItems="center">
          <Text fontWeight="bold">{value.campaign_bid}$</Text>
          <Text>{value.campaign_task_to_rate} days rate</Text>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default function Main() {
  const [previewData, setPreviewData] = React.useState({});

  function preview(data) {
    setPreviewData(data);
  }

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [sortedBy, setSortedBy] = React.useState("Most Recent");
  const [json, setJson] = React.useState([]);
  const [spinner, setSpinner] = React.useState(false);

  React.useEffect(() => {
    setSpinner(true);
    database
      .collection("campaigns")
      .get()
      .then((snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }));
        // console.log("All data in 'campaigns' collection", data);
        setJson(data);
        console.log("Running....");
      })
      .finally(() => {
        setSpinner(false);
      });
  }, []);

  const currentUser = React.useContext(LoginContext);
  const [value, setValue] = React.useState(null);
  const { colorMode, toggleColorMode } = useColorMode();
  const [loadItemsNo, setLoadItemsNo] = React.useState([
    "data",
    "data",
    "data"
  ]);

  const [modal1Data, setModal1Data] = React.useState(false);
  const [modal2Data, setModal2Data] = React.useState(false);
  const [modal3Data, setModal3Data] = React.useState(false);
  const [modal4Data, setModal4Data] = React.useState(false);
  const [modal5Data, setModal5Data] = React.useState(false);

  const [
    isMinInputMoreThanMaxInput,
    setIsMinInputMoreThanInput
  ] = React.useState(false);
  const [maxInputValue, setMaxInputValue] = React.useState(0.1);
  const [minInputValue, setMinInputValue] = React.useState(0.05);

  return (
    <Flex flexDirection="column" width="100%" className="Box">
      <NavBar />

      <Flex flexDirection="column" marginTop="7">
        <Flex
          marginTop="8"
          p={3}
          paddingStart={{ base: null, md: "75px" }}
          paddingEnd={{ base: null, md: "75px" }}
          bg="#FBC439"
          justifyContent="space-between"
          wrap="wrap">
          <Flex>
            <Wrap>
              <WrapItem>
                <Text>Refer a friend</Text>
              </WrapItem>
              <WrapItem>
                <Text>|</Text>
              </WrapItem>
              <WrapItem>
                <Text>Deposit funds </Text>
              </WrapItem>
            </Wrap>
          </Flex>
          <Flex>
            <Wrap>
              <WrapItem>
                <Text me="4">Earned: 23</Text>
              </WrapItem>
              <WrapItem>
                <Text me="4">Spendable: 43</Text>
              </WrapItem>
              <WrapItem>
                <Text me="4">pending: 56 </Text>
              </WrapItem>
            </Wrap>
          </Flex>
        </Flex>
        <Flex
          wrap="wrap"
          p={3}
          paddingStart={{ base: null, md: "75px" }}
          paddingEnd={{ base: null, md: "75px" }}
          justifyContent="space-between">
          <Text fontSize="24" fontWeight="bold">
            Find Job
          </Text>
          <Flex wrap="wrap">
            <Input
              placeholder="Enter the name of the job"
              width="290px"
              focusBorderColor="blue.500"
              marginEnd="4"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  alert("you have press Enter.");
                }
              }}
            />
            <Menu>
              <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
                Sort by / {sortedBy}
              </MenuButton>
              <MenuList>
                <MenuItem
                  onClick={() => {
                    setSortedBy("Most Recent");
                  }}>
                  Most Recent
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setSortedBy("Highest Paying");
                  }}>
                  Highest Paying
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setSortedBy("TTR");
                  }}>
                  TTR
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>

        <SimpleGrid
          p={3}
          paddingStart={{ base: null, md: "70px" }}
          columns={{ base: 1, sm: 3, md: 4, lg: 6 }}>
          <Button
            marginBottom="4px"
            rightIcon={<ChevronDownIcon />}
            marginEnd={3}
            onClick={() => {
              setModal1Data(true);
            }}>
            Job Level
          </Button>
          <Button
            marginBottom="4px"
            rightIcon={<ChevronDownIcon />}
            marginEnd={3}
            onClick={() => {
              setModal2Data(true);
            }}>
            Category
          </Button>
          <Button
            marginBottom="4px"
            rightIcon={<ChevronDownIcon />}
            marginEnd={3}
            onClick={() => {
              setModal3Data(true);
            }}>
            Sub Category
          </Button>
          <Button
            marginBottom="4px"
            rightIcon={<ChevronDownIcon />}
            marginEnd={3}
            onClick={() => {
              setModal4Data(true);
            }}>
            Price Range
          </Button>
          <Button
            marginBottom="4px"
            rightIcon={<ChevronDownIcon />}
            marginEnd={3}
            onClick={function () {
              setModal5Data(true);
            }}>
            Location
          </Button>
        </SimpleGrid>

        <Modal
          isOpen={modal1Data}
          onClose={() => {
            setModal1Data(false);
          }}
          id={1}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Job Level</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex flexDirection="column">
                <Checkbox>Starter</Checkbox>
                <Checkbox>Advanced</Checkbox>
                <Checkbox>Expert</Checkbox>
              </Flex>
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="red"
                mr={3}
                onClick={() => {
                  setModal1Data(false);
                }}>
                Clear
              </Button>
              <Button colorScheme="blue">Apply</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal
          isOpen={modal2Data}
          onClose={() => {
            setModal2Data(false);
          }}
          id={1}
          scrollBehavior="inside">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Category</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <RadioGroup onChange={setValue} value={value}>
                <Stack direction="column">
                  <Radio value="Facebook">Facebook</Radio>
                  <Radio value="Instagram">Instagram</Radio>
                  <Radio value="Twitter">Twitter</Radio>
                  <Radio value="Video Marketing">Video Marketing</Radio>
                  <Radio value="Sign Up">Sign Up</Radio>
                  <Radio value="Search, Click,(Engage)">
                    Search, Click,(Engage)
                  </Radio>
                  <Radio value="Promotion(Voting & Rating)">
                    Promotion(Voting & Rating)
                  </Radio>
                  <Radio value="Reddit">Reddit</Radio>
                  <Radio value="Yahoo Answers, Quora, etc.">
                    Yahoo Answers, Quora, etc.
                  </Radio>
                  <Radio value="Forums">Forums</Radio>
                  <Radio value="Computer Programs(PC)">
                    Computer Programs(PC)
                  </Radio>
                  <Radio value="Commment on other blogs">
                    Comment on other blogs
                  </Radio>
                  <Radio value="Write an honest review">
                    Write an honest review
                  </Radio>
                  <Radio value="Write an article">Write an article</Radio>
                  <Radio value="Mobile Applications">Mobile Applications</Radio>
                  <Radio value="Blog/Website Owners">Blog/Website Owners</Radio>
                  <Radio value="Leads">Leads</Radio>
                  <Radio value="Surveys/Offers">Surveys/Offers</Radio>
                  <Radio value="Other">Other</Radio>
                </Stack>
              </RadioGroup>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="red"
                mr={3}
                onClick={() => {
                  setModal2Data(false);
                }}>
                Clear
              </Button>
              <Button colorScheme="blue">Apply</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal
          isOpen={modal3Data}
          onClose={() => {
            setModal3Data(false);
          }}
          id={1}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Sub Category</ModalHeader>
            <ModalCloseButton />
            <ModalBody></ModalBody>

            <ModalFooter>
              <Button
                colorScheme="red"
                mr={3}
                onClick={() => {
                  setModal3Data(false);
                }}>
                Clear
              </Button>
              <Button colorScheme="blue">Apply</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal
          isOpen={modal4Data}
          onClose={() => {
            setModal4Data(false);
          }}
          id={1}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Price Range</ModalHeader>
            <ModalCloseButton
              onClick={() => {
                setIsMinInputMoreThanInput(false);
              }}
            />
            <ModalBody>
              <Text>Min. Price Range :</Text>
              <NumberInput
                min={0.02}
                max={5}
                defaultValue={0.05}
                precision={2}
                step={0.05}
                onChange={(value) => {
                  if (value >= maxInputValue) {
                    setIsMinInputMoreThanInput(true);
                  } else {
                    setIsMinInputMoreThanInput(false);
                  }
                }}>
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>

              <Text>Max. Price Range :</Text>
              <NumberInput
                min={0.02}
                max={5}
                defaultValue={0.1}
                precision={2}
                step={0.05}
                onChange={(value) => {
                  setMaxInputValue(value);
                }}>
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
              {isMinInputMoreThanMaxInput ? (
                <Text marginTop={4}>
                  Minimum Price Range must be less than Maximum Price Range.
                </Text>
              ) : null}
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="red"
                mr={3}
                onClick={() => {
                  setModal4Data(false);
                  setIsMinInputMoreThanInput(false);
                }}>
                Clear
              </Button>
              <Button colorScheme="blue" disabled={isMinInputMoreThanMaxInput}>
                Apply
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal
          isOpen={modal5Data}
          onClose={() => {
            setModal5Data(false);
          }}
          id={1}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Location</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <SimpleGrid columns={2}>
                <Checkbox>Africa</Checkbox>
                <Checkbox>Asia</Checkbox>
                <Checkbox>Carribbean</Checkbox>
                <Checkbox>Europe West</Checkbox>
                <Checkbox>Europe East</Checkbox>
                <Checkbox>International</Checkbox>
                <Checkbox>Latin America</Checkbox>
                <Checkbox>Muslim Countries</Checkbox>
                <Checkbox>USA & Western</Checkbox>
              </SimpleGrid>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="red"
                mr={3}
                onClick={() => {
                  setModal5Data(false);
                }}>
                Clear
              </Button>
              <Button colorScheme="blue">Apply</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Flex
          p={3}
          paddingStart={{ base: null, md: "75px" }}
          paddingEnd={{ base: null, md: "75px" }}
          justifyContent="space-between"
          wrap="wrap">
          <Text>345 Results</Text>
        </Flex>
        <Flex
          p={3}
          paddingStart={{ base: null, md: "75px" }}
          paddingEnd={{ base: null, md: "75px" }}
          justifyContent="space-between"
          wrap="wrap">
          <Flex
            cursor="pointer"
            _hover={{
              transform: "translateY(-2px)",
              boxShadow: "lg"
            }}
            wrap="wrap"
            flexDirection="column"
            borderWidth="2px"
            borderRadius="lg"
            width={{ base: "95vw", md: "1000px" }}
            p={4}
            marginBottom={2}>
            <Flex mb={3} justifyContent="space-between" wrap="wrap">
              <Text>Skillshare : Sign Up + Free Trial</Text>
              <SimpleGrid columns={2} spacing={2}>
                <IconButton
                  bg={colorMode === "dark" ? undefined : "white"}
                  icon={<Icon as={ExternalLinkIcon} />}
                />
                <IconButton
                  bg={colorMode === "dark" ? undefined : "white"}
                  icon={<Icon as={ViewOffIcon} />}
                />
              </SimpleGrid>
            </Flex>
            <Flex mt={3} justifyContent="space-between" wrap="wrap">
              <Text marginEnd={5}>International</Text>
              <Text marginEnd={5}>Starter</Text>
              <Flex flexDirection="column" justifyContent="space-between">
                <Text marginEnd={5}>18 of 30 Done</Text>
                <Progress
                  height="6px"
                  width="104px"
                  colorScheme="blue"
                  size="sm"
                  value={60}
                />
              </Flex>
              <Flex
                flexDirection="column"
                justsifyContent="center"
                alignItems="center">
                <Text fontWeight="bold">0.18$</Text>
                <Text>7 days rate</Text>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            display={spinner ? "flex" : "none"}
            wrap="wrap"
            flexDirection="column"
            alignItems="center"
            width={{ base: "95vw", md: "1000px" }}
            p={4}
            marginBottom={2}>
            <Spinner color="blue.400" size="lg" thickness="4px" />
          </Flex>

          {json.map((value, index) => {
            return loadList(value, index, colorMode, onOpen, preview);
          })}
        </Flex>
      </Flex>
      <Flex justifyContent="center" alignItems="center">
        <Button marginTop={8} colorScheme="blue" fontSize="sm">
          Load More
        </Button>
      </Flex>
      <Footer />
      <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Job Preview</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {/* <Text>{JSON.stringify(previewData)}</Text> */}
            <Flex m="12px">
              <Text fontSize="15" fontWeight="bold">
                {previewData.camapignTitle}
              </Text>
            </Flex>
            <Flex justifyContent="center" m="12px">
              <SimpleGrid
                columns="2"
                spacing="7px"
                borderWidth="2px"
                borderRadius="lg"
                p="12px">
                <Text fontSize="14">Job ID</Text>
                <Text fontSize="14">{previewData.id}</Text>
                <Text fontSize="14">Work Done</Text>
                <Text fontSize="14">
                  {previewData.campaign_work_done}/
                  {previewData.campaign_workers_need}
                </Text>
                <Text fontSize="14">Workers will earned</Text>
                <Text fontSize="14">{previewData.campaign_bid}</Text>
                <Text fontSize="14">Category</Text>
                <Text fontSize="14">
                  {previewData.campaign_category} {">"} Rate OR Vote
                </Text>
                <Text fontSize="14">Job Level</Text>
                <Text fontSize="14">Starter</Text>
                <Text fontSize="14">Time to Rate</Text>
                <Text fontSize="14">{previewData.campaign_task_to_rate}</Text>
                <Text fontSize="14">Target Region</Text>
                <Text fontSize="14">{previewData.campaign_region}</Text>
              </SimpleGrid>
            </Flex>

            <Flex flexDirection="column" alignItems="center" m="12px">
              <Flex
                flexDirection="column"
                borderWidth="2px"
                borderRadius="lg"
                p="12px">
                <Text fontSize="14">What is expected from workers?</Text>
                {isEmpty(previewData) === false
                  ? Object.keys(previewData.campaign_steps)
                      .sort()
                      .map((key, index) => {
                        return Steps(
                          key,
                          index,
                          previewData.campaign_steps[key]
                        );
                      })
                  : undefined}
                <Text fontSize="14" mt="12px">
                  Required proof that task was finished?
                </Text>
                {isEmpty(previewData) === false
                  ? Object.keys(previewData.campaign_proofs)
                      .sort()
                      .map((key, index) => {
                        return Proofs(
                          key,
                          index,
                          previewData.campaign_proofs[key]
                        );
                      })
                  : undefined}
              </Flex>
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Close
            </Button>
            <Button
              colorScheme="blue"
              onClick={() => {
                onClose();
                window.open(`/campaigns/${previewData.id}`, "_blank");
              }}>
              Accept
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

function Proofs(key, index, json) {
  return (
    <>
      <Text fontSize="14" ms="12px" mb="6px">
        {`${index + 1}. `}
        {json[`${key}Details`]}
      </Text>
    </>
  );
}

function Steps(key, index, json) {
  return (
    <>
      <Text fontSize="14" ms="12px">
        {`${index + 1}. `}
        {json}
      </Text>
    </>
  );
}

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}
